import {
  Box,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { getRiskColor } from "./mda-constants";
import { RiskRating } from "./mda-types";

interface MdaRiskRatingFilterProps {
  values: RiskRating[];
  options: RiskRating[];
  onChange: (event: React.MouseEvent<HTMLElement>, value: RiskRating[]) => void;
}

const MdaRiskRatingFilter = ({
  values,
  options,
  onChange,
}: MdaRiskRatingFilterProps) => (
  <Stack spacing={0.8}>
    <Typography variant="caption" sx={{ color: "#24344d", fontWeight: 700 }}>
      Risk Rating
    </Typography>
    <ToggleButtonGroup
      value={values}
      onChange={onChange}
      size="small"
      sx={{ display: "flex", gap: 0.75 }}
    >
      {options.map((rating) => (
        <ToggleButton
          key={rating}
          value={rating}
          sx={{
            flex: 1,
            border: "1px solid #d9e1ed !important",
            borderRadius: "5px !important",
            color: "#46566e",
            textTransform: "none",
            px: 1,
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&.Mui-selected, &.Mui-selected:hover": {
              backgroundColor: "#f3f7ff",
              color: "#1769ff",
              fontWeight: 700,
              borderColor: "#8bb2ff !important",
            },
          }}
        >
          <Box
            component="span"
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: getRiskColor(rating),
              mr: 0.75,
            }}
          />
          {rating}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    <Typography variant="caption" sx={{ color: "#8290a4" }}>
      Select one or more
    </Typography>
  </Stack>
);

export default MdaRiskRatingFilter;
